const Cookies = require('js-cookie');
import getTime from 'lib/time';

const TRACKED_LANDING_PAGE_COOKIE = "landing_page";
const TRACKED_LANDING_TIMESTAMP_COOKIE = "landing_page_timestamp";


// track what page the user initially lands on
export function setTrackedLandingPage(page, expirationTime) {
    // if the landing page is already tracked, do nothing
    if (Cookies.get(TRACKED_LANDING_PAGE_COOKIE)) {
        return false;
    }

    Cookies.set(TRACKED_LANDING_PAGE_COOKIE, page, { expires: expirationTime });
    Cookies.set(TRACKED_LANDING_TIMESTAMP_COOKIE, getTime(), { expires: expirationTime });

    return true;
}

// get the currently tracked landing page
export function getTrackedLandingPage() {
    return Cookies.get(TRACKED_LANDING_PAGE_COOKIE);
}

// get the timestamp of when the user first came to the site
export function getTrackedLandingTimestamp() {
    return Cookies.get(TRACKED_LANDING_TIMESTAMP_COOKIE);
}

function clearTrackedLandingPage() {
    if (Cookies.get(TRACKED_LANDING_PAGE_COOKIE)) {
        Cookies.remove(TRACKED_LANDING_PAGE_COOKIE);
    }

    return true;
}

function clearTrackedLandingTimestamp() {
    if (Cookies.get(TRACKED_LANDING_TIMESTAMP_COOKIE)) {
        Cookies.remove(TRACKED_LANDING_TIMESTAMP_COOKIE);
    }

    return true;
}

export function clearTrackedLandingCookies() {
    return clearTrackedLandingPage() && clearTrackedLandingTimestamp();
}



// WEBPACK FOOTER //
// ./assets/js/app/lib/attribution.js